import { MyCompanyPanelController } from '../controller/MyCompanyPanelController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { CompanyData } from '../../../types/company-data';

export class MyCompanyPanelWebComponent extends BaseWebComponentElement {
  public controller!: MyCompanyPanelController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MyCompanyPanelController,
    });
  }

  public get hasUnsavedChanges(): boolean {
    return this.controller.view.hasUnsavedChanges;
  }

  public selectTab(tabId, tabParams) {
    this.controller.selectTab(tabId, tabParams);
  }

  public refreshCompanyDetailsTab(company: CompanyData) {
    const companyDetailsReference = this.controller.view.dom.$companyDetails;

    if (companyDetailsReference) {
      companyDetailsReference.setEditedCompanyData(company);
      companyDetailsReference.setupMdrContactDetailsSection();
    }
  }
}
